import {
    Text as SpectrumText,
    View,
    Flex,
    Switch,
    Button,
    DialogTrigger,
    Dialog,
    Content,
    Heading,
    Divider,
} from "@adobe/react-spectrum"
import DefaultTemplate from "./templates/DefaultTemplate"
import CustomTemplate from "./templates/CustomTemplate"
import PreviewTemplate from "./templates/PreviewTemplate"
import styles from "./AddAlert.module.css"
import { useState, useEffect } from "react"
import { SlackIcon, EmailIcon } from "../../src/utilities/components/Icons"

const Template = ({
    alertName,
    index,
    state,
    isEditable,
    operation,
    updateAbandonedState,
    templateData
}) => {
    // console.log("templateData", templateData)
    const [isCustomTemplate, setIsCustomTemplate] = useState(
        state?.template?.custom || false
    )
    const [showCustomTemplateEditor, setShowCustomTemplateEditor] = useState(false)
    const [showCustomTemplateViewer, setShowCustomTemplateViewer] = useState(false)
    const [currentTemplateData, setCurrentTemplateData] = useState(state?.template || {})

    useEffect(() => {
        if (state?.template) {
            setCurrentTemplateData(state.template)
            setIsCustomTemplate(state.template.custom || false)
        }
    }, [state?.template])

    const handleSwitchChange = (value) => {
        setIsCustomTemplate(value)

        if (!value) {
            const updatedState = { ...state }
            updatedState.template = {
                custom: false,
                emailSubject: templateData?.emailSubject || "",
                emailBody: templateData?.emailBody || "",
                slackMessage: templateData?.slackMessage || "",
                slackReply: templateData?.slackReply || false,
                slackReplyMessage: templateData?.slackReplyMessage || "",
            }
            updateAbandonedState(updatedState)
            setCurrentTemplateData(updatedState.template)
        } else {
            setShowCustomTemplateEditor(true)
        }
    }

    const handleCustomTemplateData = (templateData) => {
        const updatedState = { ...state }
        updatedState.template = {
            custom: true,
            common: templateData.common,
            emailSubject: templateData.emailSubject || "",
            emailBody: templateData.emailBody || "",
            slackMessage: templateData.common ? templateData.emailBody : templateData.slackMessage || "",
            slackReply: templateData.slackReply || false,
            slackReplyMessage: templateData.slackReplyMessage || "",
        }
        updateAbandonedState(updatedState)
        setCurrentTemplateData(updatedState.template)
        setShowCustomTemplateEditor(false)
    }

    const handleEditCustomTemplate = () => {
        setShowCustomTemplateEditor(true)
    }

    const handleViewCustomTemplate = () => {
        setShowCustomTemplateViewer(true)
    }

    const handleCloseViewer = () => {
        setShowCustomTemplateViewer(false)
    }

    const handleEditFromPreview = () => {
        handleCloseViewer();
        handleEditCustomTemplate();
    }

    const isIndividualMode = () => {
        return !state?.template?.common;
    }

    return (
        <View padding={"0 0 0 3rem"}>
            <SpectrumText UNSAFE_className={styles.label}>
                Notification Template
            </SpectrumText>
            <Flex
                marginTop={"size-100"}
                alignItems={"center"}
                justifyContent={"flex-start"}
                gap={"size-100"}
            >
                <SpectrumText>Default</SpectrumText>
                <Switch
                    isEmphasized
                    isSelected={isCustomTemplate}
                    onChange={handleSwitchChange}
                />
                <SpectrumText marginStart={"-10px"}>Custom</SpectrumText>
            </Flex>
            <Flex gap={"size-200"} marginTop={"size-200"}>
                {!isCustomTemplate ? (
                    <DefaultTemplate 
                        templateData={templateData}
                    />
                ) : (
                    <Flex direction="column" gap="size-200">
                        <Flex gap="size-200">
                            <Button
                                variant="primary"
                                onPress={handleEditCustomTemplate}
                            >
                                {currentTemplateData?.custom
                                    ? "Edit Custom Template"
                                    : "Add Custom Template"}
                            </Button>
                            {currentTemplateData?.custom && (
                                <Button
                                    variant="secondary"
                                    onPress={handleViewCustomTemplate}
                                >
                                    View Custom Template
                                </Button>
                            )}
                        </Flex>

                        {showCustomTemplateEditor && (
                            <CustomTemplate
                                onSave={handleCustomTemplateData}
                                initialData={currentTemplateData}
                                isEditable={isEditable}
                                onClose={() => setShowCustomTemplateEditor(false)}
                                templateData={templateData}
                                alertName={alertName}
                            />
                        )}

                        {showCustomTemplateViewer && (
                            <PreviewTemplate
                                template={currentTemplateData}
                                isIndividualMode={isIndividualMode()}
                                onClose={handleCloseViewer}
                                onEdit={handleEditFromPreview}
                            />
                        )}
                    </Flex>
                )}
            </Flex>
        </View>
    )
}

export default Template
